export const home = '/';
export const login = '/login';
export const employeeList = '/listar-funcionarios';
export const serviceAuthorization = '/autorizacao-de-servicos';
